var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
// Importing store
import { useMediaStore } from '../../../store/media.store';
import { usePlayerStore } from '../../../store/player.store';
import { tooltipClasses } from '@mui/material/Tooltip';
// Importing 3rd party components
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
// Importing 3rd party dependencies
import { useState } from 'react';
// ----------------------------------------------------------------------
export const CaptionSelection = (props) => {
    const { children } = props;
    return (_jsx(CaptionSelectionWrapper, { title: _jsx(CaptionSelectionContent, {}), children: children }));
};
// ----------------------------------------------------------------------
export const CaptionSelectionContent = () => {
    // Adding hooks
    const { t } = useTranslation();
    // Adding media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Adding player store
    const { captions, setCaptions } = usePlayerStore(useShallow((state) => ({
        captions: state.captions,
        setCaptions: state.setCaptions,
    })));
    // Adding callback to handle selection
    const handleSelection = (event) => {
        setCaptions(event.target.value);
    };
    // Defining list of languages
    const languages = media === null || media === void 0 ? void 0 : media.captions.map((caption) => caption.srcLang);
    if (languages && languages.length > 0)
        languages.unshift('undefined');
    return (_jsx(FormControl, { sx: { mb: 1, ml: 2, mr: 2, mt: 1, minWidth: 125 }, onChange: handleSelection, children: _jsx(RadioGroup, { "aria-labelledby": "captions-label", defaultValue: "undefined", name: "captions-selection", value: captions, children: languages &&
                languages.map((language) => (_jsx(FormControlLabel, { control: _jsx(RadioStyled, {}), label: t(`languages:${language}`), value: language }, language))) }) }));
};
// ----------------------------------------------------------------------
const CaptionSelectionWrapper = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const [open, setOpen] = useState(false);
    const toggleTooltip = () => {
        setOpen(!open);
    };
    return (_jsx(Tooltip, Object.assign({}, props, { classes: { popper: className }, arrow: true, disableFocusListener: true, disableHoverListener: true, onClick: toggleTooltip, onClose: toggleTooltip, open: open, placement: "top", slots: {
            transition: Zoom,
        } })));
})(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#2b3287',
        borderRadius: 8,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#2b3287',
    },
}));
// ----------------------------------------------------------------------
const RadioStyled = styled(Radio)(({ theme }) => ({
    color: 'white',
    '&.Mui-checked': {
        color: 'white',
    },
}));
